import {useEffect} from 'react';
import {IProductShort} from 'modules/products/types';
import {EventAction, EventCategory, EventNames} from 'modules/google-analytics/constants';

import {sendGtagEvent} from 'hooks/analytics/gtag/helpers';

export const useProductsViewGtag = (
    // eslint-disable-next-line @typescript-eslint/default-param-last
    products: IProductShort[] = [],
    title: string,
    eventLocation: string,
    listText: string,
) => {
    useEffect(() => {
        const dataLayerProducts = products?.map((product, index) => {
            const productData = {} as any;
            if (title) {
                productData.brand = title;
            }
            return {
                ...productData,
                category: product.sections[0].title,
                id: product.offerId,
                list: listText,
                name: product.name,
                position: index + 1,
                price: product.price.discount.price,
            };
        });

        const dataLayerList = {
            ecommerce: {
                impressions: dataLayerProducts,
            },
            event: EventNames.OWOX,
            eventAction: EventAction.Show,
            eventCategory: EventCategory.NonInteractions,
            eventLabel: 'products',
            eventLocation,
        };
        sendGtagEvent(dataLayerList);
    }, [products, title, eventLocation, listText]);
};
